// src/hooks/useUserSubroles.js
// Thin wrapper sobre SubrolesContext — mantiene la misma API pública.
// La llamada API real está centralizada en SubrolesContext (una sola vez por sesión).
import { useSubroles } from '../contexts/SubrolesContext';

export const useUserSubroles = () => useSubroles();
